// The page-view BAND measurement, shared by every pager (the chart sheets'
// PagedSheet and the score surface's pager in NotationPane). Kept out of the
// component files so fast-refresh stays clean.
//
// Rect-based on purpose: the pages grid's document top and the fixed
// transport bar are both scroll-invariant, so the numbers hold at any scroll
// position, and focus mode's collapsed chrome grows the band for free.

/** Breathing room above the transport bar. */
export const SHEET_BAND_BREATH = 10;
/** Never plan pages shorter than this — a pathological measurement (transport
 * mid-animation, a zero-height flash) must not explode the page count. */
export const MIN_SHEET_PAGE_HEIGHT = 240;

export interface SheetBand {
  availWidth: number;
  availHeight: number;
}

export function measureSheetBand(container: HTMLElement, pagesEl: HTMLElement): SheetBand {
  const availWidth = container.clientWidth;
  // The pages grid's own document top (below the masthead), so pages fit the
  // remaining band without any scrolling at all in the common case.
  const docTop = pagesEl.getBoundingClientRect().top + window.scrollY;
  const transport = document.querySelector('.transport-bar');
  const transportTop = transport
    ? Math.min(window.innerHeight, Math.max(0, transport.getBoundingClientRect().top))
    : window.innerHeight;
  const availHeight = Math.max(MIN_SHEET_PAGE_HEIGHT, transportTop - docTop - SHEET_BAND_BREATH);
  return { availWidth, availHeight };
}
